import {useEffect, useState} from 'react'
import {listProjectSelectionOptions} from '../api'
import {PROJECTS_UPDATED_EVENT} from '../constants'
import {ProjectSummary} from '../models'

export const useProjectSelectionOptions = (includeArchived: boolean) => {
  const [projects, setProjects] = useState<ProjectSummary[]>([])
  const [loading, setLoading] = useState(true)
  const [loadedFor, setLoadedFor] = useState<boolean>()
  const [error, setError] = useState<string>()
  const [revision, setRevision] = useState(0)
  useEffect(() => {
    const refresh = () => setRevision((value) => value + 1)
    window.addEventListener(PROJECTS_UPDATED_EVENT, refresh)
    return () => window.removeEventListener(PROJECTS_UPDATED_EVENT, refresh)
  }, [])
  useEffect(() => {
    const controller = new AbortController()
    setLoading(true)
    setError(undefined)
    listProjectSelectionOptions(includeArchived, controller.signal)
      .then((items) => { if (!controller.signal.aborted) setProjects(items) })
      .catch(() => { if (!controller.signal.aborted) setError('Unable to load projects.') })
      .finally(() => {
        if (!controller.signal.aborted) {
          setLoadedFor(includeArchived)
          setLoading(false)
        }
      })
    return () => controller.abort()
  }, [includeArchived, revision])
  return {projects, loading: loading || loadedFor !== includeArchived, error, refresh: () => setRevision((value) => value + 1)}
}
